import style from './index.module.scss';

export const PageLayout = ({ children, ...props }: any) => {
  return (
    <div className={`${style.page} ${props.className || ''}`}>{children}</div>
  );
};
